module.exports = __webpack_public_path__ + "img/nutrison.0b0e66d2.png";